import Tooltip from './Tooltip'
import { useTooltip } from './useTooltip'

export type BarRow = { label: string; value: number; count: number }

/**
 * Horizontal bars: one per row, label on the left, value at the bar's tip.
 * Bars share one scale (the biggest row fills the track) and grow from a common baseline.
 */
export default function BarList({
  rows,
  formatValue,
  unit = 'project',
}: {
  rows: BarRow[]
  formatValue: (value: number) => string
  unit?: string
}) {
  const { ref, tip, bind } = useTooltip<HTMLDivElement>()
  const max = Math.max(...rows.map((r) => r.value), 1)

  return (
    <div className="bar-list" ref={ref}>
      {rows.map((r) => {
        const valueText = `${formatValue(r.value)} · ${r.count}`
        const tipText = `${formatValue(r.value)} · ${r.count} ${unit}${r.count === 1 ? '' : 's'}`
        return (
          // role="img": a focusable mark whose label carries its value for screen readers.
          <div key={r.label} className="bar-row" role="img" {...bind(tipText, r.label)}>
            <span className="bar-label">{r.label}</span>
            <span className="bar-track">
              <span className="bar" style={{ width: `${(r.value / max) * 100}%` }} />
              <span className="bar-value">{valueText}</span>
            </span>
          </div>
        )
      })}
      <Tooltip tip={tip} />
    </div>
  )
}
